<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as ELIGIBILITY_TYPES } from './store'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import EligibilityTable from './EligibilityTable.vue'
export default {
  name: 'EligibilityList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': EligibilityTable
  },
  data () {
    return {
      title: this.$t('Eligibility - Active Customer'),
      fieldName: 'id',
      searchFields: [],
      showCommonFilters: false,
      showAdvancedSearch: false,
      toggleAdvancedSearch: false,
      showHeader: false,
      rolePerm: 'document_uploaddocument_deadline_health_suitability_list'
    }
  },
  computed: {
    ...mapGetters({
      ...ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.GETTERS
    }),
    canAddInstance () {
      return false
    },
    canSeeActionSelect () {
      return false
    }
  },
  methods: {
    ...mapMutations({
      setOrderBy: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.MUTATIONS.setOrderBy
    }),
    ...mapActions({
      ...ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.ACTIONS
    })
  }
}
</script>
